// General Lock — "Casino List", in the REFERENCE's order.
//
// Since 2026-09-22 the SERVER serves this list already ordered and labelled
// (model/admin/TableCasino.js FIXED_TABLES: 171 rows, `sort_order`, the
// reference's labels; /admin/table-casino/list orders by sort_order). This
// file is the FALLBACK for a server that has not been restarted onto that
// seed yet — it reorders and relabels the old 81-row response so the screen is
// right either way. It changes nothing when the rows already arrive in order.
//
// Read off the reference General Lock page DOM (admin/excepted.txt,
// 2026-09-22): 171 rows, [gtype, label]. The order is neither by key nor by
// name — it is the order the reference's own casino list carries, so it is
// held here as data, exactly as data/seriesOrderSeed.js holds the league order.
//
// Our /admin/table-casino/list returns the DB's `table_casino` rows (81 today)
// as { id, tableid, tablename }: the page places each row by `tableid` (the
// same key as this list's first column), falling back to the label, and shows
// THIS list's label. Rows the list does not know go last, in the order they
// came. The list is an ORDER only — it never adds a table the DB does not have
// (a lock is stored against the DB row's id).
//
// Regenerating: open the reference's General Lock, copy the Casino List <ul>,
// take (value, label) from each row's checkbox + label.

export const CASINO_LOCK_ORDER = [
  ['Teen', 'Teenpatti 1-day'],
  ['poker', 'Poker 1-Day'],
  ['3cardj', '3 Cards Judgement'],
  ['aaa', 'Amar Akbar Anthony'],
  ['ab20', 'Andar Bahar'],
  ['abj', 'Andar Bahar 2'],
  ['baccarat', 'Baccarat'],
  ['baccarat2', 'Baccarat 2'],
  ['btable', 'Bollywood Casino'],
  ['card32', '32 Cards A'],
  ['card32eu', '32 Cards B'],
  ['cmatch20', 'Cricket Match 20-20'],
  ['cmeter', 'Casino Meter'],
  ['CricketV', 'Cricket V'],
  ['CricketV2', 'Cricket V2'],
  ['cricketv3', '5Five Cricket'],
  ['dt20', '20-20 Dragon Tiger'],
  ['dt202', '20-20 Dragon Tiger 2'],
  ['dt6', '1 Day Dragon Tiger'],
  ['dtl20', '20-20 D T L'],
  ['lottcard', 'lottcard'],
  ['lucky7', 'Lucky 7 - A'],
  ['lucky7eu', 'Lucky 7 - B'],
  ['poker20', '20-20 Poker'],
  ['poker6', 'Poker 6 Players'],
  ['teen20', '20-20 Teenpatti'],
  ['teen8', 'Teenpatti Open'],
  ['teen9', 'Teenpatti Test'],
  ['war', 'Casino War'],
  ['worli', 'Worli Matka'],
  ['worli2', 'Instant Worli'],
  ['dream', 'Diam11'],
  ['daba', 'Player Battle'],
  ['runner', 'Runner'],
  ['cockfight', 'Cockfight'],
  ['ezugi', 'Ezugi'],
  ['ss', 'Super Spade'],
  ['qt', 'QTech'],
  ['evo', 'Evolution'],
  ['teen6', 'Teenpatti - 2.0'],
  ['queen', 'Queen'],
  ['race20', 'Race20'],
  ['pop-the-ball', 'Pop The Ball'],
  ['lucky7eu2', 'Lucky 7 - C'],
  ['superover', 'Super Over'],
  ['trap', 'The Trap'],
  ['binary', 'Binary'],
  ['ludo-club', 'Ludo Club'],
  ['patti2', '2 Cards Teenpatti'],
  ['teensin', '29Card Baccarat'],
  ['teenmuf', 'Muflis Teenpatti'],
  ['rummy', 'Rummy'],
  ['slot', 'Slot'],
  ['tgs', 'Slot 2'],
  ['race17', 'Race to 17'],
  ['teen20b', '20-20 Teenpatti B'],
  ['TGSLive', 'VivoGames-LuckyStreak'],
  ['trio', 'Trio'],
  ['notenum', 'Note Number'],
  ['teen2024', 'Teen 20 24'],
  ['kbc', 'K.B.C'],
  ['ludo-lands', 'Ludo Lands'],
  ['teen120', '1 CARD 20-20'],
  ['teen1', '1 CARD ONE-DAY'],
  ['vteen20', 'V-20-20 Teenpatti'],
  ['vteen', 'V-Teenpatti 1-day'],
  ['vdt6', 'V-1 Day Dragon Tiger'],
  ['vdt20', 'V-20-20 Dragon Tiger'],
  ['vlucky7', 'V-Lucky 7 - A'],
  ['vrace17', 'V-Race to 17'],
  ['vteenmuf', 'V-Muflis Teenpatti'],
  ['vaaa', 'V-Amar Akbar Anthony'],
  ['vbtable', 'V-Bollywood Casino'],
  ['vbaccarat', 'V-Baccarat'],
  ['vtrio', 'V-Trio'],
  ['vtrap', 'V-The Trap'],
  ['ab3', 'ANDAR BAHAR 50 CARDS'],
  ['vdtl20', 'V-20-20 D T L'],
  ['aaa2', 'Amar Akbar Anthony 2'],
  ['vivo', 'Vivo Gaming'],
  ['snakes-and-ladders', 'snakes and ladders'],
  ['roulette', 'roulette'],
  ['race2', 'Race to 2nd'],
  ['Astar', 'Astar Game'],
  ['smart', 'Smart Soft'],
  ['teen3', 'Instant Teenpatti'],
  ['bc', 'Creedroomz'],
  ['dum10', 'Dus ka Dum'],
  ['cmeter1', '1 Card Meter'],
  ['bota', 'Bota'],
  ['tembo', 'Tembo'],
  ['ds', 'Dragoon Soft'],
  ['av', 'Spribe'],
  ['bcslot', 'Pascal Game'],
  ['lottery', 'Lottery'],
  ['radar', 'sportbook'],
  ['bti', 'sportbook 1'],
  ['teen32', 'Instant Teenpatti 2.0'],
  ['prgslot', 'Pragamatic slot'],
  ['prglive', 'Pragamatic live'],
  ['SicBo', 'Sic Bo'],
  ['ballbyball', 'Ball by ball'],
  ['roulette1', 'roulette1'],
  ['teen33', 'Instant Teenpatti 3.0'],
  ['Scratch', 'Scratch'],
  ['roulette2', 'roulette2'],
  ['superover2', 'Super Over2'],
  ['roulette3', 'roulette3'],
  ['sicbo2', 'Sic Bo 2'],
  ['Darwin', 'Darwin'],
  ['Teen41', 'Queen top open teenpatti'],
  ['Teen42', 'Jack top open teenpatti'],
  ['Lucky15', 'Lucky 15'],
  ['goal', 'Goal'],
  ['pg', 'Pocket Game'],
  ['ab4', 'Andar-Bahar 150 card'],
  ['superover3', 'Mini SuperOver'],
  ['ourroullete', 'Unique Roulette'],
  ['Teen20c', '20-20 Teenpatti C'],
  ['btable2', 'Bollywood Casino 2'],
  ['bet', 'betcore'],
  ['teenjoker', 'Teenpatti Joker'],
  ['gemini1', 'Gemini'],
  ['Jilli', 'Jilli'],
  ['gemini2', 'gemini live'],
  ['Win', 'Red Carat'],
  ['joker1', 'Unlimited Joker One Day'],
  ['Joker20', 'Teenpatti Joker 20-20'],
  ['Joker120', 'Unlimited Joker 20-20'],
  ['poison20', 'Teenpatti Poison 20-20'],
  ['Amigo', 'Amigo'],
  ['teenunique', 'Unique Teenpatti'],
  ['poison', 'Teenpatti Poison One Day'],
  ['Roulette11', 'VIP Roulette'],
  ['Roulette12', 'Beach Roulette'],
  ['Roulette13', 'Regular Roulette'],
  ['egt', 'EGT'],
  ['pteen', 'Premium Teenpatti 1-day'],
  ['pteen20', 'Premium 20-20 Teenpatti'],
  ['pdt6', 'Premium 1 Day Dragon Tiger'],
  ['pdt20', 'Premium 20-20 Dragon Tiger'],
  ['plucky7', 'Premium Lucky 7'],
  ['pcard32', 'Premium 32 Cards'],
  ['pbaccarat', 'Premium Baccarat'],
  ['tteen', 'Tembo Teenpatti 1-day'],
  ['tteen20', 'Tembo 20-20 Teenpatti'],
  ['tdt6', 'Tembo 1 Day Dragon Tiger'],
  ['tdt20', 'Tembo 20-20 Dragon Tiger'],
  ['tlucky7', 'Tembo Lucky 7'],
  ['tcard32', 'Tembo 32 Cards'],
  ['tbaccarat', 'Tembo Baccarat'],
  ['Lucky5', 'Lucky 6'],
  ['Mogambo', 'Mogambo'],
  ['dolidana', 'Dolidana'],
  ['exa', 'EXA'],
  ['studio21', 'Studio21'],
  ['teen20v', '20-20 Teenpatti VIP'],
  ['Worli3', 'Matka'],
  ['GVI', 'GVI'],
  ['teen62', 'V VIP Teenpatti 1-day'],
  ['beon', 'Beon Gaming'],
  ['Playtech', 'Play Tech'],
  ['King', 'king'],
  ['bb', 'DimCL'],
  ['avnew', 'Aviator New'],
  ['Goal2', 'Goal 2'],
  ['exanew1', 'EXA Live'],
  ['exanew2', 'EXA Fantasy'],
  ['exanew3', 'EXA Slot'],
  ['dimfantasy', 'Fantasy'],
  ['teenholdem', 'Teenpatti Holdem'],
]

// The DB spells these 13 tables differently from the reference (or the same as a
// different reference table), so their label
// alone cannot place them. Until the list API sends `tableid` (server change
// of 2026-09-22, live after the next restart) the key is recovered from the
// DB's own label here. [db label, key] — taken from model/admin/TableCasino.js.
const DB_LABEL_TO_KEY = new Map([
  ['mini super over', 'superover3'],
  ['Dragon Tiger Lion', 'dtl20'],
  ['Dragon Tiger 202', 'dt202'],
  ['Kaun Banega Crorepati', 'kbc'],
  ['Race 20', 'race20'],
  ['Andar Bahar 20', 'ab20'],
  ['AB Joker', 'abj'],
  ['Andar Bahar 150 Cards', 'ab4'],
  ['Worli Matka 3', 'worli3'],
  ['Teenpatti 2.0', 'teen6'],
  ['Unlimited Joker Oneday', 'joker1'],
  // these two DB labels also exist on the reference — under a DIFFERENT key —
  // so a label lookup alone would place them under the wrong row
  ['Roulette', 'roulette13'],
  ['Lottery', 'lottcard'],
].map(([label, key]) => [label.toLowerCase(), key]))

// key -> position and label -> position, lower-cased, built once
const BY_KEY = new Map(CASINO_LOCK_ORDER.map(([key], i) => [key.toLowerCase(), i]))
const BY_LABEL = new Map(CASINO_LOCK_ORDER.map(([, label], i) => [label.toLowerCase().trim(), i]))
const norm = (v) => String(v ?? '').toLowerCase().trim()

/** The DB's casino rows, reordered to the reference list, each carrying the
 *  REFERENCE's label as `tablename` (user, 2026-09-22: keep the key, show the
 *  reference's name — "Andar Bahar 2", not the DB's "AB Joker"). A row is
 *  placed by its key (`tableid`), falling back to the label for a row that
 *  carries no key. Rows the list does not know keep their relative order, their
 *  own label, and go after every known one. Stable. The DB is not touched — the
 *  lock is stored against the row's `id`, and the key is what the reference
 *  keys on too. */
export function orderCasinoRows(rows) {
  return rows
    .map((row, i) => {
      // the DB label wins over the reference's label when both exist: two DB
      // rows ("Roulette" = roulette13, "Lottery" = lottcard) share a label with
      // a DIFFERENT reference key, and the label-only path would place them
      // under the wrong one
      const key = norm(row?.tableid) || norm(DB_LABEL_TO_KEY.get(norm(row?.tablename)))
      const pos = BY_KEY.get(key) ?? BY_LABEL.get(norm(row?.tablename))
      const known = pos !== undefined
      return {
        row: known ? { ...row, tablename: CASINO_LOCK_ORDER[pos][1] } : row,
        i,
        pos: known ? pos : CASINO_LOCK_ORDER.length + i,
      }
    })
    .sort((a, b) => a.pos - b.pos || a.i - b.i)
    .map((x) => x.row)
}
